class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // Safety check for Overlay
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    
    this.setHeaderCartIconAccessibility();

    initSubscribeAndSaveToggles();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // CART DRAWER OPEN
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Animation trigger
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (containerToTrapFocusOn && focusElement) trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  // CART DRAWER CLOSE
  close() {
    this.classList.remove('active');
    if (this.activeElement) removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  // CART NOTE
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (cartDrawerNote.parentElement) cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  
  renderContents(parsedState, shouldOpen = true) {
    if (parsedState?.id || (parsedState?.sections && parsedState.sections['cart-drawer'])) {
      const inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (sectionElement) {
          const sectionHtml = parsedState.sections ? parsedState.sections[section.id] : parsedState;
          sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        }
      });

      this.runCartLogic(false);
      if (shouldOpen) setTimeout(() => this.open(), 100);

    } else {
      fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const drawer = document.querySelector('.drawer');
          if (drawer) drawer.classList.remove('is-empty');
          
          const newContent = html.querySelector('#CartDrawer');
          const currentContent = document.querySelector('#CartDrawer');
          if (currentContent && newContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }
        }).finally(() => {
          this.runCartLogic(false);
          if (shouldOpen) setTimeout(() => this.open(), 100);
        });
    }
  }

  // Ensures the drawer opens even if a single function fails
  runCartLogic(shouldOpen = false) {
    try { if (typeof checkAndRemoveItems === 'function') checkAndRemoveItems(); } catch(e) { console.error(e); }
    try { if (typeof enforceVariantLimits === 'function') enforceVariantLimits(); } catch(e) { console.error(e); }
    try { if (typeof checkAndRemoveFreebies === 'function') checkAndRemoveFreebies(); } catch(e) { console.error(e); }
    try { if (typeof checkCartTotal === 'function') checkCartTotal(); } catch(e) { console.error(e); }
    try { if (typeof checkCartProducts === 'function') checkCartProducts(); } catch(e) { console.error(e); }
    try { if (typeof loadTogglestate === 'function') loadTogglestate(); } catch(e) { console.error(e); }
    try { if (typeof wishlistRender === 'function') wishlistRender(); } catch(e) { console.error(e); }
    try { if (typeof fetchCartItemsCount === 'function') fetchCartItemsCount(); } catch(e) { console.error(e); }

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      if (shouldOpen) this.open();
    }, 50);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : html;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section'
      // }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// CART ITEMS COUNT - Adptation for bundles - counts them as one item not multiples
function fetchCartItemsCount(bundleHandler = false) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => response.json())
    .then((cart) => {
      const uniqueItems = {};

      cart.items.forEach((item) => {
        if (item.properties && item.properties._rc_bundle) {
          const bundleId = item.properties._rc_bundle;

          if (!uniqueItems[bundleId]) {
            uniqueItems[bundleId] = item.quantity;
          }
        } else {

          uniqueItems[item.key] = item.quantity;
        }
      });
      
      const cDW = document.querySelector('cart-drawer');
      const totalUniqueProducts = Object.keys(uniqueItems).length;
      const counterContainer = document.querySelector('.cart-count-bubble [aria-hidden="true"]');

      if (counterContainer) {
        counterContainer.textContent = `${totalUniqueProducts > 0 ? totalUniqueProducts : ""}`;
      }
      if (bundleHandler && cDW) {
        setTimeout(() => {
          cDW.classList.toggle('is-empty', totalUniqueProducts === 0);
        }, 500);
      }
    })
    .catch((error) => console.error('Error fetching cart:', error));
}
fetchCartItemsCount();


// BUNDLE REMOVAL -  removal of an entire (recharge) bundle
async function checkAndRemoveRechargeItems(bundleId) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(cart => {
      const updates = cart.items.reduce((acc, item, index) => {
        if (item.properties && item.properties._rc_bundle === bundleId) {
          acc[item.key] = 0;
        }
        return acc;
      }, {});

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
    })
    .then(response => response.json())
    .then(updatedCart => {
      console.log('Updated cart:', updatedCart);
    })
    .catch(error => console.error('Error updating cart:', error));
}


/** DISCO KIT Pop Up - not in use right now
function openpopupInsideDrawer() {
  const clickcartPU = document.getElementById("showPUcart");
  const popupcart = document.getElementById("addon-popup-cart");
  const closecartPU = document.getElementById("hidePU");
  const closecartPUx = document.getElementById("hidePUx");

  if (clickcartPU && popupcart && closecartPU && closecartPUx) {
    clickcartPU.addEventListener('click', () => {
      popupcart.style.display = 'block';
    });
    
    popupcart.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPU.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPUx.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
  }
}
**/


// RENDER WISHLIST
function wishlistRender(){
  const wishlist_full = document.getElementById("wishlist-items");
  if (wishlist_full) {
    if (wishlist_full.innerHTML.trim() !== '') {
        // Wishlist is loaded, element is not empty
        //console.log('Element is not empty');
      } else {
        // Wishlist is not loaded, element is empty
        //console.log('Element is empty');
        //loading cart wishlist js
        setTimeout(() => {},1000)
        const script_1 = document.createElement('script');
        script_1.src = cart_wishlist_widget_url;
        script_1.crossOrigin = "anonymous";
        script_1.defer = true;
        document.body.appendChild(script_1);
      }
    }
  }
wishlistRender()

// KIT CHECK & REMOVE ITEMS - If cart has gift/deluxe kit &  standard kit products then remove. + Load VIP toggle
function checkAndRemoveItems() {
  loadTogglestate();
  hideVIPIfSessionStorageExists('vipatc', 'vipatcClose');
  console.log('checking products HAS!!!');
  //Removing Regular Kit when upgrade to deluxe
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let hasGiftKitIndex = -1;
    
        cart.items.some((item, index) => {
            if (idsGiftKist.includes(item.product_id)) {
                hasGiftKitIndex = idsGiftKist.indexOf(item.product_id);
                return true;
            }
            return false;
        }); 

        if (hasGiftKitIndex !== -1) {
          let removeId = removeProductIfHasGiftKits[hasGiftKitIndex];
          let elementToRemove = document.querySelector(`cart-drawer-items .cart-item[data-productid="${removeId}"]`);
          if (elementToRemove) {
            elementToRemove.querySelector('cart-remove-button').click();
              //console.log(`Removed item with ID: ${removeId}`);
          }
        }
    })
    .catch(error => console.error('Error fetching cart:', error));
}


//VIP FREEBIE LOGIC
//const freebieProductId = 14785127219563;
//const customerIsVIP = {% if customer and customer.tags contains 'tier: VIP' %}true{% else %}false{% endif %};
function checkAndRemoveFreebies() {
  if (typeof customerIsVIP === 'undefined' || typeof freebieProductId === 'undefined') {
    console.error('Error: Required variables are not defined. Please ensure they are set in your Liquid file.');
    return;
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartSubtotal = cart.total_price / 100;
      const freebiesInCart = cart.items.filter(item => item.product_id === freebieProductId);
      const updates = {};
      let needsUpdate = false;

      // RULE 1: If cart total is below $99, remove ALL freebies.
      if (cartSubtotal < 99 && freebiesInCart.length > 0) {
        freebiesInCart.forEach(item => {
          updates[item.key] = 0;
        });
        needsUpdate = true;
        console.log('Cart subtotal is below $99. Removing all freebies.');
      }
      
      // RULE 2: Only check for VIP logic if the cart total is $99 or more
      else if (customerIsVIP) {
        // VIP LOGIC: If a VIP has more than two freebies, remove the extras.
        if (freebiesInCart.length > 2) {
          const itemsToRemove = freebiesInCart.slice(2);
          itemsToRemove.forEach(item => {
            updates[item.key] = 0;
          });
          needsUpdate = true;
          console.log('VIP limit exceeded. Removing extra freebies.');
        }
      } 
      
      // RULE 3: If a customer is NOT a VIP, remove ALL freebies (only if cart total is $99 or more)
      else if (!customerIsVIP && freebiesInCart.length > 0) {
          freebiesInCart.forEach(item => {
            updates[item.key] = 0;
          });
          needsUpdate = true;
          console.log('Non-VIP customer detected. Removing all freebies.');
      }

      if (needsUpdate) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then(response => response.json())
          .then(updatedCart => {
            console.log('Cart API updated with freebie changes.');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents({ sections: { 'cart-drawer': updatedCart } });
            } else {
              window.location.reload(); 
            }
          })
          .catch(error => {
            console.error('Error removing items from cart:', error);
          });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}


// FORCES SPECIFIC VARIANTS TO MAX QUANTITY OF 1
function enforceVariantLimits() {
  const restrictedVariantIds = [
      20633669795910,  // 8piece Kit OG
      40102681509991,  // Deluxe Kit - OG
      52898730541419,  // Free Welcome Gifts: Deluxe 17-Piece Kit ($20)
      52898735718763,  // Free Welcome Gifts: Light Show Eye Gel
      52898739257707,  // Free Welcome Gifts: Smooth Sailing Retinol Eye Cream
      52898722120043,  // Free Welcome Gifts: Soulmate Brightening Treatment
      52955998716267,  // Free Welcome Gifts: Deluxe 17-Piece Kit ($75 Value)
      53019329659243,  // Free Welcome Gifts: Lip trick
      53019335393643,  // Free Welcome Gifts: Mini Seeking C
      53019332313451,  // Free Welcome gifts: Mini Up The Anti
      53115324727659,  // Free Welcome gifts: Zen Out of Ten
      53115328987499,  // Free Welcome gifts: Seeking C Full Size
      53115324727659,  // Free Welcome gifts: Hit The Spot
      53361920016747,  // Free Welcome gifts: Mini Pep Rally
      53361919721835,  // Free Welcome gifts: Mini Soulmate
      53427147112811,  // Free Welcome gifts: Neoprene Travel Case
      53427146457451   // Free Welcome gifts: Micro Dermaroller
    // Add more IDs here as needed
  ];

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const updates = {};
      let needsUpdate = false;

      cart.items.forEach(item => {
        // Check if the current item variant ID is in our restricted list
        if (restrictedVariantIds.includes(item.variant_id)) {
          if (item.quantity > 1) {
            updates[item.key] = 1; // Force quantity to 1
            needsUpdate = true;
          }
        }
      });

      if (needsUpdate) {
        console.log('Variant limit enforced: Reducing quantity to 1 for restricted items.');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
        .then(response => response.json())
        .then(updatedCart => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(updatedCart);
          }
        })
        .catch(error => console.error('Error enforcing variant limits:', error));
      }
    });
}

// CHECK CART TOTAL - GET CART PRICE TOTAL & PRODUCT IDS IN CART
function checkCartTotal() {
  return fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
   
    const totalPrice = cart.total_price / 100;

    const productLists = cart.items.map(item => item.id);

    return {
      totalPrice,
      productLists
    };
  })
  .catch(error => {
    console.error('Помилка при отриманні кошика:', error);
    return null; 
  });
}

// Kit VIP ATC close
function vipClose() {
  const vipatc = document.getElementById("vipatc");
  vipatc.style.display = "none";
  sessionStorage.setItem('vipatcClose', 'true');
}

// Kit VIP ATC storage session
function hideVIPIfSessionStorageExists(elementId, sessionStorageKey) {
  if (sessionStorage.getItem(sessionStorageKey)) {
    const vipelement = document.getElementById(elementId);
    if (vipelement) {
      vipelement.style.display = 'none';
    }
  }
}
hideVIPIfSessionStorageExists('vipatc', 'vipatcClose');

// Loading VIP toggle State
function loadTogglestate () {
  const vipCheckbox = document.getElementById('perk_cart_toggle');
  const checkboxKey = 'myCheckboxState';
  if (vipCheckbox) {
    // On page load, retrieve the checkbox state from session storage
    window.addEventListener('load', () => {
      const storedState = sessionStorage.getItem(checkboxKey);
      if (storedState) {
        vipCheckbox.checked = JSON.parse(storedState);
        if (vipCheckbox.checked) {
          //console.log("Checkbox true");
          const checkoutButton = document.getElementById('CartDrawer-Checkout');
          const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');
          checkoutButton.classList.add('checkout_hide');
          vipcheckoutButton.classList.remove('checkout_hide');
        }
      }
    });
  };
}
loadTogglestate()


function initSubscribeAndSaveToggles() {
  if (window.__subscribeToggleBound) return;
  window.__subscribeToggleBound = true;

  const getQuantityForInput = (input) => {
    let quantity = Number.parseInt(input?.dataset?.quantity || '1', 10);
    if (!Number.isFinite(quantity) || quantity < 1) {
      const cartItem = input?.closest('.cart-item');
      const qtyInput = cartItem ? cartItem.querySelector('input[name="updates[]"]') : null;
      const qtyValue = qtyInput ? qtyInput.value : '1';
      quantity = Number.parseInt(qtyValue, 10);
    }
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    return quantity;
  };

  const updateSellingPlan = async ({ itemKey, quantity, sellingPlanId, inputEl }) => {
    if (!itemKey) return;
    if (inputEl) inputEl.disabled = true;
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('is-loading');
      const loader = drawer.querySelector('.cart-drawer__loader');
      if (loader) loader.hidden = false;
    }

    try {
      const payload = {
        id: itemKey,
        quantity,
        selling_plan: sellingPlanId,
        sections: 'cart-drawer',
        properties: {}
      };

      if (sellingPlanId) {
        payload.selling_plan = sellingPlanId;
        payload.properties._subscription_toggle = 1;
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const parsedState = await response.json();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error updating subscription toggle:', error);
      if (inputEl) {
        inputEl.checked = !inputEl.checked;
        inputEl.disabled = false;
      }
    } finally {
      if (drawer) {
        drawer.classList.remove('is-loading');
        const loader = drawer.querySelector('.cart-drawer__loader');
        if (loader) loader.hidden = true;
      }
    }
  };

  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!input || !input.matches('.drawer-toggle__input')) return;

    const itemKey = input.dataset.itemKey;
    const quantity = getQuantityForInput(input);

    const availablePlans = (input.dataset.availablePlans || '')
      .split(',')
      .map((entry) => entry.trim())
      .filter(Boolean);

    if (!itemKey) return;

    let targetPlanId = null;
    if (input.checked) {
      if (!availablePlans.length) return;
      const sixtyPlan = availablePlans.find((entry) => /60\s*-?\s*day/i.test(entry));
      const fallbackPlan = availablePlans[0];
      const selected = sixtyPlan || fallbackPlan;
      const parts = selected.split('|');
      targetPlanId = parts.length > 1 ? parseInt(parts[parts.length - 1], 10) : null;
      if (!targetPlanId) return;
    }

    await updateSellingPlan({ itemKey, quantity, sellingPlanId: targetPlanId, inputEl: input });
  });

  document.addEventListener('click', async (event) => {
    const editButton = event.target.closest('.drawer-subscribe-edit');
    if (editButton) {
      const container = editButton.closest('.drawer-subscribe-and-save')?.closest('.cart-item')?.querySelector('.drawer-subscribe-meta') || editButton.closest('.drawer-subscribe-meta');
      const dropdown = container ? container.querySelector('.drawer-subscribe-dropdown') : null;
      if (dropdown) {
        dropdown.hidden = !dropdown.hidden;
        editButton.textContent = dropdown.hidden ? 'Edit' : 'Cancel';
      }
      return;
    }

    const optionButton = event.target.closest('.drawer-subscribe-option');
    if (!optionButton) return;

    const container = optionButton.closest('.drawer-subscribe-meta');
    const itemKey = container ? container.dataset.itemKey : null;
    const toggleInput = container ? container.closest('.cart-item')?.querySelector('.drawer-toggle__input') : null;
    const quantity = getQuantityForInput(container || toggleInput);
    const sellingPlanId = Number.parseInt(optionButton.dataset.planId || '', 10);
    if (!Number.isFinite(sellingPlanId)) return;

    if (toggleInput) toggleInput.checked = true;
    await updateSellingPlan({ itemKey, quantity, sellingPlanId, inputEl: toggleInput });
  });
}


// FUNCTION: LOAD VIP TOGGLE
function loadVIPtoggle() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasProduct1 = false;
      let hasProduct2 = false;
      let hasVip = false;         
      cart.items.forEach(item => {
        if (item.product_id === productIds[0]) {
          hasProduct1 = true;
        }
        if (item.product_id === productIds[1]) {
          hasProduct2 = true;
        }
        if (item.product_id === vipIds[0] || item.product_id === vipIds[1] || item.product_id === vipIds[2] ) {
          hasVip = true;
          sessionStorage.setItem('vipatcClose', 'true');
        }
      });

      const viptoggle = document.getElementById('perk_cart_toggle');
      const checkoutButton = document.getElementById('CartDrawer-Checkout');
      const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');  
      const checkboxKey = 'myCheckboxState';

    if (viptoggle) {
      if (hasProduct1 || hasProduct2 ) {
        if (hasVip) {
          sessionStorage.removeItem('myCheckboxState');
        };
        viptoggle.addEventListener('change', () => {
          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));         
          if (viptoggle.checked) {      
              //console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')          
            } else {
              //console.log("Opting Out - No VIP Offer");
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };         
        });  
      } else if (hasVip) {
        //console.log("VIP in cart");
        sessionStorage.removeItem('myCheckboxState');    
        
      } else { 
        viptoggle.addEventListener('change', () => {

          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));       
          if (viptoggle.checked) {      
              //console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')
              //regsubtotal.classList.add('checkout_hide')
              //vipsubtotal.classList.remove('checkout_hide')         
            } else {
              //console.log("Opting Out - No VIP Offer");
              //regsubtotal.classList.remove('checkout_hide')
              //vipsubtotal.classList.add('checkout_hide')
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };
          
        });                                                                                 
      }
    }
  })
  .catch(error => {      
  });
} 

// DISCOUNT CODE CHECK FUNCTION - Not in use - will double check later if can comment out 2/3/26
function hasSpecificDiscount(lineItem, discountCode) {
  if (lineItem.discounts && lineItem.discounts.length > 0) {
    for (const discount of lineItem.discounts) {
      if (discount.code && discount.code.toLowerCase() === discountCode.toLowerCase()) {
        return true;
      }
    }
  }
  return false;
}

// Global tracker to monitor NC discount count across cart refreshes
let lastNcDiscountCount = 0;

function getTideTrueGiftUpdates(cart, plannedUpdates = {}) {
  const updates = {};
  const items = cart.items || [];
  items.forEach((gift) => {
    const properties = gift.properties || {};
    if (properties._tide_true_gift !== 'true') return;
    if ((plannedUpdates[gift.key] ?? plannedUpdates[gift.variant_id]) === 0) return;
    const variant = Number(properties._tide_true_parent_variant);
    const plan = Number(properties._tide_true_parent_plan);
    const requiredQuantity = Number(properties._tide_true_parent_quantity);
    const validRule = Number.isSafeInteger(variant) && variant > 0 &&
      Number.isSafeInteger(plan) && plan >= 0 &&
      Number.isSafeInteger(requiredQuantity) && requiredQuantity > 0 &&
      properties._tide_true_parent_plan !== undefined;
    const quantity = validRule ? items.reduce((total, item) => {
      if (item.properties?._tide_true_offer !== 'upgrade' ||
          item.properties?._tide_true_gift === 'true' ||
          Number(item.variant_id) !== variant ||
          Number(item.selling_plan_allocation?.selling_plan?.id || 0) !== plan) return total;
      const plannedQuantity = plannedUpdates[item.key] ?? plannedUpdates[item.variant_id] ?? item.quantity;
      return total + Number(plannedQuantity);
    }, 0) : 0;
    if (!validRule || quantity < requiredQuantity || gift.selling_plan_allocation) {
      updates[gift.key] = 0;
    } else if (gift.quantity !== 1) {
      updates[gift.key] = 1;
    }
  });
  return updates;
}

function checkCartProducts() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(async (cart) => {
      // 1. EXIT/CLEAR IF EMPTY
      if (!cart || (Array.isArray(cart.items) && cart.items.length === 0)) {
        sessionStorage.removeItem('myCheckboxState');
        lastNcDiscountCount = 0;
        fetch("/discount/CLEAR");
        return;
      };

      // Configurable Gift Rules - UPDATED to use arrays for both gifts and required products
      const GIFT_RULES = [
        {
          giftVariantIds: [53793412448619],         // HSN Free Gift
          requiredVariantIds: [53791047319915],     // Required parent variant(s)
          requiresSubscription: true                // Set true or false
        },
        {
          giftVariantIds: [53836805636459],         // Bank On It Gummies Free Gift
          requiredVariantIds: [53832270676331],     // Required parent variant(s)
          requiresSubscription: true                // Set true or false
        },
        {
          giftVariantIds: [53839765078379],         // Bank On It Powder Free Gift
          requiredVariantIds: [53832271724907],     // Required parent variant(s)
          requiresSubscription: true                // Set true or false
        },
        {
          giftVariantIds: [53988286038379],         // Bank On It Collagen DUo
          requiredVariantIds: [53988263723371],     // Required parent variant(s)
          requiresSubscription: true                // Set true or false
        },
        {
          // NEW RULE: Multiple gifts tied to one parent variant
          giftVariantIds: [
            53867888279915, // clips
            53867888345451, // tide
            53867888312683  // uppa mini
          ],         
          requiredVariantIds: [53867923964267],     // Required parent variant(s)
          requiresSubscription: false               // No subscription requirement mentioned
        }
      ];

      const isSubscriptionItem = (item) => Boolean(
        item.selling_plan_allocation || 
        item.selling_plan || 
        (item.properties && item.properties._subscription_toggle)
      );

      // Updated to flatMap since giftVariantIds is now an array
      const validGiftIds = new Set(
        GIFT_RULES
          .filter(rule => 
            cart.items.some(item => 
              rule.requiredVariantIds.includes(item.variant_id) && 
              (!rule.requiresSubscription || isSubscriptionItem(item))
            )
          )
          .flatMap(rule => rule.giftVariantIds) 
      );

      // 2. FLAGS & IDS
      let hasProduct1 = cart.items.some(item => item.product_id === productIds[0]); // Regular Kit
      let hasProduct2 = cart.items.some(item => item.product_id === productIds[1]); // Deluxe Kit
      let haskitVip = cart.items.some(item => item.product_id === kitVip[0]); // Kit 8pc - FREE w/ VIP
      let currentNcDiscountCount = 0;
      let hasNEW25applied = false;
      let hasNCcodes = false;
      let hasSuperOffer = cart.items.some(item => superOfferVariants.includes(item.variant_id));
      //ES Starter Routine
      let hasSpecialBypassVariant = cart.items.some(item => item.variant_id === 53418782425451);

      // List of variants to delete if NEW25 is applied
      const deleteIfNew25 = [
        20633669795910,  // 8piece Kit OG
        40102681509991,  // Deluxe Kit - OG
        14908775891307,  // 8piece Kit + VIP
        52898730541419,  // Free Welcome Gifts: Deluxe 17-Piece Kit
        52898735718763,  // Free Welcome Gifts: Light Show Eye Gel
        52898739257707,  // Free Welcome Gifts: Smooth Sailing Retinol Eye Cream
        52898722120043,  // Free Welcome Gifts: Soulmate Brightening Treatment
        52955998716267,  // Free Welcome Gifts: Deluxe 17-Piece Kit ($75 Value)
        53019329659243,  // Free Welcome Gifts: Lip trick
        53019335393643,  // Free Welcome Gifts: Mini Seeking C
        53019332313451,  // Free Welcome gifts: Mini Up The Anti
        53115324727659,  // Free Welcome gifts: Zen Out of Ten
        53115328987499,  // Free Welcome gifts: Seeking C Full Size
        53115324727659,  // Free Welcome gifts: Hit The Spot
        53361920016747,  // Free Welcome gifts: Mini Pep Rally
        53361919721835,  // Free Welcome gifts: Mini Soulmate
        53427147112811,  // Free Welcome gifts: Neoprene Travel Case
        53361919721835,  // Free Welcome gifts: Micro Dermaroller
        53261298270571,  // All For Glow Routine - 30 Day Supply
        53261298303339   // All For Glow Routine - 90 Day Supply
      ];

      // BLACKLISTED (Always remove if found)
      const blacklistedVariants = [
        52073836740971, // New25 GWP Deluxe Kit
        52073845686635, // New25 GWP Light Show
        52587248419179, // New25 GWP Welcome Gifts Bundle
        52777639805291, // New25 Takeover GWP Gift1 
        52777639969131  // New25 Takeover GWP Gift2 
      ];

      // RESTRICTED (Remove if NC(new customer) code count drops or is missing)
      const restrictedncVariants = [
        52898730541419,  // Free Welcome Gifts: Deluxe 17-Piece Kit
        52898735718763,  // Free Welcome Gifts: Light Show Eye Gel
        52898739257707,  // Free Welcome Gifts: Smooth Sailing Retinol Eye Cream
        52898722120043,  // Free Welcome Gifts: Soulmate Brightening Treatment
        52955998716267,  // Free Welcome Gifts: Deluxe 17-Piece Kit ($75 Value)
        53019329659243,  // Free Welcome Gifts: Lip trick
        53019335393643,  // Free Welcome Gifts: Mini Seeking C
        53019332313451,  // Free Welcome gifts: Mini Up The Anti
        53115324727659,  // Free Welcome gifts: Zen Out of Ten
        53115328987499,  // Free Welcome gifts: Seeking C Full Size
        53115324727659,  // Free Welcome gifts: Hit The Spot
        53267377553771,  // Free Welcome gifts: Daydreamer Full Size
        53267407176043,  // Free Welcome gifts: Down To Earth Full Size
        53361920016747,  // Free Welcome gifts: Mini Pep Rally
        53361919721835,  // Free Welcome gifts: Mini Soulmate
        53427147112811,  // Free Welcome gifts: Neoprene Travel Case
        53427146457451   // Free Welcome gifts: Micro Dermaroller
      ];

      // Separate list for NC codes that allow restricted variants but kill GWPs
      const ncCodesList = [
        'BUNDLE-NC-60OFF', 'BUNDLE-NC-50OFF', 'BUNDLE-NC-45OFF', 
        'BUNDLE-NC-35OFF', 'WELCOME-NC-15OFF', 'WELCOME-NC-36OFF', 
        'WELCOME-NC-50OFF', 'WELCOME-NC-57OFF', 'NC25OFF', 'NC35OFF', 'NCSAVE', 'VIP35OFF',
        'NC-PICK2', 'NC-PICK2-SNS', 'NC-PICK3', 'NC-PICK3-SNS', 'NC-PICK4', 'NC-PICK4-SNS',
        'HELLOSAINTS25', 'HELLOSAINTS35', 'SAINT34'
      ];

      // 3. SCAN CART FOR DISCOUNTS & BUNDLES
      console.group('NC Discount Security Scan');
      cart.items.forEach(item => {
        let itemHasNcDiscount = false;
        
        if (item.discounts && item.discounts.length > 0) {
          item.discounts.forEach(discount => {
            if (discount.title === 'NEW25') {
              hasNEW25applied = true;
            }
            if (ncCodesList.includes(discount.title)) {
              hasNCcodes = true;
              itemHasNcDiscount = true;
            }
          });
        }
        
        if (itemHasNcDiscount) currentNcDiscountCount += item.quantity;

        if (item.product_title?.toLowerCase().includes('bundle & save')) {
          hasNEW25applied = true;
        }
      });
      console.log(`Final NC Discount Quantity Count: ${currentNcDiscountCount}`);
      console.log(`Previous NC Count: ${lastNcDiscountCount}`);
      console.groupEnd();

      // 4. DEFINE GWP SETS 
      let activeGwps = [];
      let activeThresholds = [];

      if (hasNCcodes || hasSuperOffer) {
        console.log('GWP Structure: NC Codes (Empty Set)');
        activeGwps = [];
        activeThresholds = [];
      } else if (hasNEW25applied) {
        console.log('GWP Structure: NEW25');
        activeGwps = ncGwps;
        activeThresholds = ncThresholds;
      } else if (hasProduct2) {
        console.log('GWP Structure: Deluxe Kit');
        activeGwps = deluxeGwps;
        activeThresholds = deluxeThresholds;
      } else if (hasProduct1 || haskitVip) {
        console.log('GWP Structure: Regular Kit');
        activeGwps = kitGwps;
        activeThresholds = kitThresholds;
      } else {
        console.log('GWP Structure: Sitewide');
        activeGwps = swGwps;
        activeThresholds = swThresholds;
      }

      // 5. CALCULATE UPDATES
      const totalPrice = cart.total_price / 100;
      const updates = {};
      const toAdd = [];
      const currentVids = cart.items.map(i => i.variant_id);
      const allPossibleGwps = [...swGwps, ...kitGwps, ...deluxeGwps, ...ncGwps];

      const forceRemoveRestricted = (currentNcDiscountCount < lastNcDiscountCount || !hasNCcodes) && !hasSuperOffer && !hasSpecialBypassVariant;

      cart.items.forEach(item => {
        const vid = item.variant_id;

        // AA. Remove managed gifts if prerequisite conditions are not met (Updated to check array)
        const isManagedGift = GIFT_RULES.some(rule => rule.giftVariantIds.includes(vid));
        if (isManagedGift && !validGiftIds.has(vid)) {
          console.warn(`Removing gift (${vid}): Parent product or subscription condition not met.`);
          updates[item.key] = 0;
        }
        
        // A. Remove NEW25 restricted variables
        if (hasNEW25applied && deleteIfNew25.includes(vid)) {
          console.log(`NEW25 detected. Removing forbidden variant: ${vid}`);
          updates[item.key] = 0;
        }
      
        // B. Remove Blacklisted (Always)
        if (blacklistedVariants.includes(vid)) updates[item.key] = 0;

        // C. Remove Restricted if security check fails
        if (forceRemoveRestricted && restrictedncVariants.includes(vid)) {
          console.warn(`Security Trigger: Removing restricted item ${vid} due to NC count drop.`);
          updates[item.key] = 0;
        }

        // D. Cleanup: Remove GWPs from non-active sets 
        if (allPossibleGwps.includes(vid) && !activeGwps.includes(vid)) updates[item.key] = 0;

        // E. Remove FREE VIP variant if kits don't exist
        if (!hasProduct1 && !hasProduct2 && vid === 53031898710379) {
           updates[item.key] = 0;
        }

        // F. Remove FREE VIP variant if haskitVip is false
        if (!haskitVip && vid === 53031898743147) {
           updates[item.key] = 0;
        }

        // G. Conflict Protection: NC code and SuperOffer
        if (hasNCcodes && hasSuperOffer) {
          if (superOfferVariants.includes(vid) || restrictedncVariants.includes(vid)) {
            console.warn(`Abuse Prevention: Both NC Code and SuperOffer detected. Removing item ${vid}.`);
            updates[item.key] = 0;
          }
        }
      });

      lastNcDiscountCount = currentNcDiscountCount;

      // E. Threshold check for current Active Set
      activeGwps.forEach((id, index) => {
        if (!id || id === 'null' || id === 0) return;
        const threshold = activeThresholds[index];
        const inCart = currentVids.includes(id);

        if (totalPrice >= threshold) {
          if (!inCart) toAdd.push({ id: id, quantity: 1, properties: { '_gwp': 'true' } });
        } else if (inCart) {
          updates[id] = 0;
        }
      });

      Object.assign(updates, getTideTrueGiftUpdates(cart, updates));

      // 6. EXECUTE API CALLS
      if (Object.keys(updates).length > 0 || toAdd.length > 0) {
        console.log('GWP IDs Adding:', toAdd);
        console.log('GWP IDs Removing (Updates):', updates);
        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
        if (toAdd.length > 0) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: toAdd })
          });
        }
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.renderContents();
        return; 
      }

      // 7. PDP UI FIXES
      const discoveryButton = document.querySelector('#showPU[data-id="2043719581766"]');
      if (discoveryButton) {
        const shouldDisable = (hasProduct1 || hasProduct2 || hasNEW25applied || hasNCcodes || haskitVip);
        discoveryButton.classList.toggle('discovery-hasin-cart', shouldDisable);
        discoveryButton.disabled = shouldDisable;
      }

      // 8. LOAD VIP TOGGLE
      loadVIPtoggle();
    })
    .catch(error => console.error('GWP Logic Error:', error));
}


// PDP CHECK - IS THIS PRODUCT PAGE TRUE OR FALSE
function isThisProductPage() {
  const analyticsScript = document.getElementById('shop-js-analytics');

  if (analyticsScript) {
    const analyticsData = JSON.parse(analyticsScript.textContent);

    if (analyticsData.pageType === 'product') {
      return true;
    }
  }

  return false;
}

// RECHECK PRODUCTS ON PAGE LOAD
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    checkCartProducts();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.renderContents(null, false);
  } else {
    checkCartProducts();
  }
  startOrUpdateCartTimer();
});

// triggerAutoOpenSequence IIFE
(() => {
  const triggerAutoOpenSequence = () => {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('open_cart')) {
      urlParams.delete('open_cart');
      const cleanedSearch = urlParams.toString();
      const cleanedURL = window.location.pathname + (cleanedSearch ? '?' + cleanedSearch : '');
      window.history.replaceState({}, document.title, cleanedURL);

      const drawer = document.querySelector('cart-drawer');
      
      if (drawer) {
        const inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        drawer.classList.remove('is-empty');

        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents(null, true);
        } else if (typeof drawer.open === 'function') {
          drawer.open();
        }
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', triggerAutoOpenSequence);
  } else {
    triggerAutoOpenSequence();
  }
})();